// import axios from "axios";
// import { createNewHmac } from './hmacUtils';

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// // API request function
// export const apiRequest = async (endpoint, method, data = null, headers = {}) => {
//   const url = `${API_BASE_URL}${endpoint}`; // Ensure the URL is constructed properly
//   const access_token = localStorage.getItem('token');

//   const currentTime = new Date().toISOString(); // Get the current time in ISO format
//   const options = {
//     method: method,
//     headers: {
//       ...headers,
//       'X-Current-Time': currentTime, // Add current time to headers
//     },
//   };

//   // Handle POST and PUT requests with request body
//   if (data) {
//     let dataHmac = data;
//     const hmac = createNewHmac(dataHmac);

//     if (data instanceof FormData) {
//       data.append('userHmac', hmac);
//     } else {
//       data.userHmac = hmac;
//     }
//     options.data = data;
//   } else {
//     const hmacPayload = { token: `Bearer ${access_token}` };
//     const hmac = createNewHmac(hmacPayload);
//     options.headers.userHmac = hmac;
//   }

//   try {
//     const response = await axios(url, options);

//     if (!response) {
//       throw new Error(`Error: ${response.status}`);
//     }

//     return response;
//   } catch (error) {
//     console.error("API request failed:", error);
//     throw error;
//   }
// };

import axios from "axios";
import { createNewHmac } from "./hmacUtils";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const apiRequest = async (
  endpoint,
  method,
  data = null,
  headers = {},
) => {
  const url = `${API_BASE_URL}${endpoint}`;
  const accessToken = localStorage.getItem("token");

  const currentTime = new Date().toISOString();

  const options = {
    method,
    headers: {
      ...headers,
    },
  };

  if (accessToken) {
    options.headers.Authorization = `Bearer ${accessToken}`;
  }

  if (data) {
    if (data instanceof FormData) {
      const hmacPayload = {};

      for (const [key, value] of data.entries()) {
        if (!(value instanceof File)) {
          hmacPayload[key] = value;
        }
      }

      hmacPayload.newTime = currentTime;

      const hmac = createNewHmac(hmacPayload);

      data.append("newTime", currentTime);
      data.append("userHmac", hmac);

      options.data = data;
    } else {
      const payload = {
        ...data,
        newTime: currentTime,
      };

      payload.userHmac = createNewHmac(payload);

      options.data = payload;
    }
  } else {
    const tokenHeader = accessToken ? `Bearer ${accessToken}` : "";

    const hmacPayload = {
      token: tokenHeader,
    };

    options.headers.userHmac = createNewHmac(hmacPayload);
  }

  try {
    const response = await axios(url, options);
    return response;
  } catch (error) {
    console.error("API request failed:", error?.response?.data || error);
    throw error;
  }
};
